import Treatments from './Treatment.container';

export default Treatments;
